module.exports = __webpack_public_path__ + "media/images/frontend/twitter-772d1bdb5c460997476a9e259f883cec.svg";